export default {
    FULL: 'full',
    SHORT: 'short'
}; 